import React from 'react';
import { componentService } from 'js/services/component.service';

export const ReduxComponentExample = React.lazy(() => import(/* webpackChunkName: "redux-component-example" */ './ReduxComponentExample'));

componentService.registerWebContentComponents({ ReduxComponentExample });
